var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanetBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 109,
    viewBox: "0 0 180 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.4633 102.287C122.888 99.0002 141.645 74.9145 138.358 48.4901C135.071 22.0656 110.986 3.30871 84.5613 6.59537C58.1368 9.88202 39.3799 33.9676 42.6666 60.3921C45.9532 86.8166 70.0388 105.573 96.4633 102.287Z",
    fill: "url(#paint0_linear_2_568)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.835 25.1783C129.994 26.6924 131.059 28.2893 132.041 29.969C138.818 28.9162 143.219 29.3066 144.106 31.3648C144.993 33.423 142.249 36.877 136.831 41.0763C128.22 47.7477 112.854 56.3118 94.685 64.1425C76.5159 71.9614 59.7426 77.2489 48.9784 78.9168C42.2004 79.9695 37.8119 79.591 36.9129 77.5328C36.0258 75.4627 38.7701 72.0087 44.1877 67.8095C43.6435 65.9405 43.2177 64.0716 42.9102 62.1908C16.1651 76.1725 -0.83294 88.2852 1.15431 92.9221C3.14155 97.559 23.6291 93.5254 52.1721 83.6956C65.3377 79.177 80.2065 73.4045 95.7733 66.7094C111.34 60.0024 125.748 53.1535 138.085 46.695C164.83 32.7014 181.84 20.6005 179.841 15.9636C177.842 11.3267 157.366 15.3603 128.811 25.1783H128.835Z",
    fill: "#3000E0",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_568",
    x1: 29.6413,
    y1: 39.5463,
    x2: 156.352,
    y2: 39.5463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF43F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3000E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetBottom);
export default __webpack_public_path__ + "static/media/planetBottom.9ad5248afb55cd6a80ab526032b32081.svg";
export { ForwardRef as ReactComponent };